module.exports = __webpack_public_path__ + "static/logo-d14865995d484dd3dc25514035e28a9f.png";